import React from "react";
import myImg from "../../Assets/shanto_avatar.jpg";
import GitHubCalendar from "react-github-calendar";

const info = [
  { label: "Location",     value: "Gazipur, Dhaka, Bangladesh" },
  { label: "University",   value: "IUT — BSc CS (2022–2026)" },
  { label: "GPA",          value: "3.39 / 4.0" },
  { label: "Email",        value: "sakibahmed21@iut-dhaka.edu" },
  { label: "Experience",   value: "2+ Years in Mobile Dev" },
  { label: "Status",       value: "Open to opportunities ✅" },
];

function AboutSection() {
  return (
    <section id="about" className="sp-section sp-section-alt">
      <div className="sp-container">
        <div className="sp-section-header">
          <span className="section-label">Who I am</span>
          <h2 className="section-title">
            About <span className="gradient-text">Me</span>
          </h2>
        </div>

        <div className="about-two-col">
          {/* Left: avatar + info */}
          <div className="about-left">
            <div className="about-avatar-wrap">
              <img src={myImg} alt="Sakib Ahmed Shanto" className="about-avatar-img" />
              <div className="about-avatar-glow" />
            </div>

            <div className="about-info-grid">
              {info.map(({ label, value }) => (
                <div className="about-info-item" key={label}>
                  <div className="label">{label}</div>
                  <div className="value">{value}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: bio */}
          <div className="about-right">
            <p className="about-text">
              I'm a passionate <strong style={{ color: "#a78bfa" }}>Flutter &amp; Mobile Application Developer</strong> with
              2+ years of hands-on experience designing, building, and shipping production apps to both the{" "}
              <strong style={{ color: "#67e8f9" }}>Google Play Store</strong> and{" "}
              <strong style={{ color: "#67e8f9" }}>Apple App Store</strong>.
            </p>
            <p className="about-text">
              As the <strong style={{ color: "#a78bfa" }}>sole mobile developer</strong> at TanAinent Global UK LTD,
              I owned the complete lifecycle of Rahiee.AI — an AI-powered HR management app — from Xcode setup and
              CocoaPods integration through Apple Review, provisioning profiles, FCM compliance, and final App Store
              launch. On the Android side, I managed staged rollouts via Google Play Console including app signing,
              release tracks, and policy compliance.
            </p>
            <p className="about-text">
              Beyond client work, I've shipped open-source contributions to the official{" "}
              <strong style={{ color: "#a78bfa" }}>Arduino Library Manager</strong>, built AR experiences with
              ARCore, and won multiple national &amp; international hackathons — including a{" "}
              <strong style={{ color: "#fbbf24" }}>Silver Medal</strong> at the{" "}
              <strong style={{ color: "#fbbf24" }}>International Blockchain Olympiad 2025, Hong Kong</strong>.
            </p>

            <div className="about-tags">
              {["Clean Architecture","BLoC / GetX","Firebase","ARCore","CI/CD","Arduino / ESP32","App Store Connect","Google Play Console"].map((t) => (
                <span className="tag" key={t}>{t}</span>
              ))}
            </div>

            <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", marginTop: "24px" }}>
              <a href="https://github.com/sakibahmedshanto" target="_blank" rel="noreferrer" className="btn-primary-hero" style={{ fontSize: "0.88rem", padding: "10px 22px" }}>
                GitHub ↗
              </a>
              <a href="https://www.linkedin.com/in/sakibsanto/" target="_blank" rel="noreferrer" className="btn-secondary-hero" style={{ fontSize: "0.88rem", padding: "10px 22px" }}>
                LinkedIn ↗
              </a>
            </div>
          </div>
        </div>

        {/* GitHub calendar */}
        <div className="github-calendar-wrap">
          <div className="sp-section-header" style={{ marginBottom: "16px" }}>
            <span className="section-label">Activity</span>
            <h3 className="section-title" style={{ fontSize: "1.6rem" }}>
              Days I <span className="gradient-text">Code</span>
            </h3>
          </div>

          {/* Live apps stat */}
          <div style={{ display: "flex", justifyContent: "center", marginBottom: "28px" }}>
            <div style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "10px",
              background: "linear-gradient(135deg, rgba(57,255,20,0.12), rgba(31,215,96,0.08))",
              border: "1px solid rgba(57,255,20,0.35)",
              borderRadius: "50px",
              padding: "10px 24px",
              fontSize: "0.95rem",
              color: "#d1fae5",
              fontWeight: "500",
              letterSpacing: "0.02em",
            }}>
              <span style={{ fontSize: "1.2rem" }}>🚀</span>
              I have more than&nbsp;<strong style={{ color: "#39ff14", fontSize: "1.05rem" }}>5+ apps</strong>&nbsp;active &amp; live on stores
            </div>
          </div>

          <div style={{ display: "flex", justifyContent: "center", overflowX: "auto" }}>
            <GitHubCalendar
              username="sakibahmedshanto"
              blockSize={13}
              blockMargin={2}
              color="hsl(210, 8%, 15%)"
              theme={{
                light: ["#ebedf0", "#c6e48b", "#7bc96f", "#239a3b", "#00dd00"],
                dark: ["#0e1117", "#0d3922", "#06753d", "#26a641", "#00ff00"]
              }}
              fontSize={12}
              hideTotalCount={false}
              hideColorLegend={false}
              hideMonthLabels={false}
              hideDaysLabels={false}
            />
          </div>

          <div style={{ marginTop: "16px", textAlign: "center" }}>
            <a href="https://docs.github.com/en/github/setting-up-and-managing-your-github-profile/managing-contribution-settings-on-your-profile"
               target="_blank" rel="noreferrer"
               style={{ fontSize: "0.85rem", color: "rgba(255,255,255,0.5)", textDecoration: "none" }}>
              Learn how we count contributions
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutSection;
